import React, { useEffect, useState, useRef } from "react";
import "../scss/_stage.scss";

const Stage = () => {
  const [mousePosition, setMousePosition] = useState({ x: 0, y: 0 });
  const [isMobile, setIsMobile] = useState(false);
  const stageRef = useRef(null);

  useEffect(() => {
    // Mobile detection
    const checkIsMobile = () => {
      setIsMobile(window.innerWidth <= 768 || "ontouchstart" in window);
    };

    checkIsMobile();
    window.addEventListener("resize", checkIsMobile);

    const handleMouseMove = (e) => {
      if (!isMobile && stageRef.current) {
        const rect = stageRef.current.getBoundingClientRect();
        const centerX = rect.left + rect.width / 2;
        const centerY = rect.top + rect.height / 2;

        // Berechne relative Position zur Mitte des Elements
        const x = (e.clientX - centerX) / rect.width;
        const y = (e.clientY - centerY) / rect.height;

        // Begrenze die Werte und skaliere sie für den Parallax-Effekt
        const parallaxX = Math.max(-1, Math.min(1, x)) * 20; // Max 20px Bewegung
        const parallaxY = Math.max(-1, Math.min(1, y)) * 20; // Max 20px Bewegung

        setMousePosition({ x: parallaxX, y: parallaxY });
      }
    };

    const handleDeviceOrientation = (e) => {
      if (isMobile) {
        // DeviceOrientationEvent Werte:
        // beta: Neigung vor/zurück (-180 bis 180)
        // gamma: Neigung links/rechts (-90 bis 90)

        const beta = e.beta || 0; // Vor/zurück Neigung
        const gamma = e.gamma || 0; // Links/rechts Neigung

        // Normalisiere die Werte und skaliere sie
        // Beta: -30 bis 30 Grad als sinnvoller Bereich
        // Gamma: -30 bis 30 Grad als sinnvoller Bereich
        const normalizedX = Math.max(-1, Math.min(1, gamma / 30)) * 15; // Max 15px
        const normalizedY = Math.max(-1, Math.min(1, beta / 30)) * 15; // Max 15px

        setMousePosition({ x: normalizedX, y: normalizedY });
      }
    };

    const requestOrientationPermission = async () => {
      if (isMobile && typeof DeviceOrientationEvent !== "undefined") {
        // iOS 13+ benötigt explizite Erlaubnis
        if (typeof DeviceOrientationEvent.requestPermission === "function") {
          try {
            const permission = await DeviceOrientationEvent.requestPermission();
            if (permission === "granted") {
              window.addEventListener(
                "deviceorientation",
                handleDeviceOrientation
              );
            }
          } catch (error) {
            console.log("DeviceOrientation permission denied");
          }
        } else {
          // Andere Browser/Versionen
          window.addEventListener("deviceorientation", handleDeviceOrientation);
        }
      }
    };

    if (isMobile) {
      requestOrientationPermission();
    } else {
      window.addEventListener("mousemove", handleMouseMove);
    }

    return () => {
      window.removeEventListener("mousemove", handleMouseMove);
      window.removeEventListener("deviceorientation", handleDeviceOrientation);
      window.removeEventListener("resize", checkIsMobile);
    };
  }, [isMobile]);

  return (
    <section
      className="stage"
      ref={stageRef}
      style={{
        "--mouse-x": `${mousePosition.x}px`,
        "--mouse-y": `${mousePosition.y}px`,
      }}
    >
      <div className="stage--content-intro">
        Share <span className="symbol">share</span> your Hans Zimmer Live experience and win one of ten exclusive
        merchandise packages <span className="symbol">package</span> including a program booklet signed <span className="symbol">signature</span> by Hans Zimmer!
      </div>

      <div className="stage--content">
        <h2>How to enter:</h2>
        <ol>
          <li>
            Share your Hans Zimmer Live photos with the hashtag
            <br />
            <a
              target="_blank"
              rel="noreferrer"
              href="https://www.instagram.com/explore/search/keyword/?q=%23hanszimmerlive"
            >
              #hanszimmerlive
            </a>
          </li>
          <li>
            Tag our Hans Zimmer Live tour account on your photo
            <br />
            <a
              target="_blank"
              rel="noreferrer"
              href="https://www.instagram.com/hanszimmerlive"
            >
              @hanszimmerlive
            </a>
          </li>
          <li>
            And finally sign up to our free Hans Zimmer Live newsletter
            <br />
            <a href="#optin">Sign up</a>
          </li>
        </ol>
      </div>
    </section>
  );
};

export default Stage;
